export {
  LockedBadge,
  PreOrderBadge,
  OnHoldBadge,
  RecentlyAddedBadge
} from './Badges';
